<template>
  <div>
    <el-form-item :label="language('shopInformation.briefDescription')">
      <div class="input">
        <el-input
          v-model="form['briefDescription']"
          type="textarea"
          :rows="5"
          :maxlength="60"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 60 ' +
            language('shopInformation.words') +
            tips(form['briefDescription'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>

    <el-form-item :label="language('shopInformation.briefDescriptionEng')">
      <div class="input">
        <el-input
          v-model="form['langList'][0].value"
          type="textarea"
          :rows="5"
          :maxlength="120"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 120 ' +
            language('shopInformation.words') +
            tips(form['langList'][0].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>

    <el-form-item :label="language('shopInformation.longDescription')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['longDescription']"
          :maxlength="1200"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 1200 ' +
            language('shopInformation.words') +
            tips(form['longDescription'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.longDescriptionEng')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['langList'][1].value"
          :maxlength="2400"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 2400 ' +
            language('shopInformation.words') +
            tips(form['langList'][1].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>

    <el-form-item :label="language('shopInformation.metaKeyword')">
      <div class="input">
        <el-input
          v-model="form['metaKeyword']"
          type="textarea"
          :rows="5"
          :maxlength="150"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 150 ' +
            language('shopInformation.words') +
            tips(form['metaKeyword'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.metaKeywordEng')">
      <div class="input">
        <el-input
          v-model="form['langList'][2].value"
          type="textarea"
          :rows="5"
          :maxlength="300"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 300 ' +
            language('shopInformation.words') +
            tips(form['langList'][2].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>

    <el-form-item :label="language('shopInformation.mateDescription')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['metaDescription']"
          :maxlength="150"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 150 ' +
            language('shopInformation.words') +
            tips(form['metaDescription'])
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
    <el-form-item :label="language('shopInformation.mateDescriptionEnd')">
      <div class="input">
        <el-input
          type="textarea"
          :rows="5"
          v-model="form['langList'][3].value"
          :maxlength="300"
        ></el-input>
        <el-alert
          type="info"
          show-icon
          :title="
            language('shopInformation.max') +
            ' 300 ' +
            language('shopInformation.words') +
            tips(form['langList'][3].value)
          "
          :closable="false"
        ></el-alert>
      </div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  model: {
    prop: "forms",
    event: "change",
  },
  props: {
    formData: Object,
  },
  data() {
    return {
      nameArr: [
        "briefDescription",
        "longDescription",
        "metaKeyword",
        "metaDescription",
      ],
      form: {
        langList: [
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "briefDescription", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "longDescription", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "metaKeyword", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "metaDescription", //字段
            appId: "supnr",
          },
        ],
      },
    };
  },
  watch: {
    form: {
      handler() {
        this.$emit("change", this.form);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    tips(text) {
      if (text) {
        return (
          this.language("shopInformation.maxTips1") +
          text.length +
          this.language("shopInformation.maxTips2")
        );
      }
      return "";
    },
  },
  mounted() {
    if (this.formData.id) {
      let langList = [];
      for (let i = 0; i < this.formData.langList.length; i++) {
        if (this.nameArr.indexOf(this.formData.langList[i].name) > -1) {
          langList.push(this.formData.langList[i]);
        }
      }

      if (this.formData.langList.length == 0) {
        langList = [
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "briefDescription", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "longDescription", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "metaKeyword", //字段
            appId: "supnr",
          },
          {
            refId: "", //商店id//修改的时候需要
            lang: "english", //语言
            value: "", //值
            name: "metaDescription", //字段
            appId: "supnr",
          },
        ];
      }
      this.form = {
        briefDescription: this.formData.briefDescription,
        langList: langList,
        longDescription: this.formData.longDescription,
        metaKeyword: this.formData.metaKeyword,
        metaDescription: this.formData.metaDescription,
      };
      this.$emit("change", this.form);
    } else {
      // this.$emit("change", this.form);
    }
  },
};
</script>
<style>
.el-alert {
  padding-top: 0;
  padding-bottom: 0;
}
</style>
<style scoped>
.input {
  width: 400px;
}
</style>